export default __webpack_public_path__ + "static/media/silver_badge.b8de6edf.svg";